/** IMPORTS */
/** libraries */
import * as React from 'react';
import { Tabs, TabLink, TabContent } from 'react-tabs-redux';
import { translate } from 'react-i18next';
const { connect } = require('react-redux');
import { IStore } from 'redux/IStore';
import { RouteComponentProps } from 'react-router';
/** models */
import * as c from 'models/constants';
import { IUserPreferences } from 'models/user/userpreferences';
import { ISearchData, ISearchAction } from 'models/search/search';
import { changeTabAndGetRequiredData, resetSearchData } from 'redux/modules/search/search';
import { ArticleSearchResults, UserSearchResults, ProductSearchResults, ShopSearchResults } from 'containers';
import { PortalOneColumnLayout } from 'components/PortalStructure';
import { SearchUsage } from 'models/enums/searchusage';
import { goToCard } from 'helpers/common';
import { RootCategory } from 'models';
const { asyncConnect } = require('redux-connect');
import { Helmet } from 'react-helmet';
/** styles */
require('./style.css');

interface IProps extends RouteComponentProps<IParams, {}> {
	userPreferences?: IUserPreferences;
	search?: ISearchData;
	t?: (key: string) => string;
	changeTabAndGetRequiredData?: (
		selectedTab: string,
		category: number,
		keyword: string,
		order: number,
		r1: number,
		r2: number,
		r3: boolean,
		r4: string,
		r5: string,
	) => ISearchAction;
	resetSearchData?: () => ISearchAction;
	dispatch?: any;
}

interface IParams {
	keyword: string;
}
@asyncConnect([
	{
		promise: () => {
			return Promise.all([]);
		},
	},
])
@connect(
	(state: IStore) => ({
		userPreferences: state.userPreferences,
		search: state.search,
	}),
	(dispatch) => ({
		changeTabAndGetRequiredData: (
			selectedTab: string,
			category: number,
			keyword: string,
			order: number,
			r1: number,
			r2: number,
			r3: boolean,
			r4: string,
			r5: string,
		) => dispatch(changeTabAndGetRequiredData(selectedTab, category, keyword, order, r1, r2, r3, r4, r5)),
		resetSearchData: () => dispatch(resetSearchData()),
		dispatch,
	}),
)
@translate(c.DEFAULT_TRANSLATION_NAMESPACE)
class SearchResults extends React.Component<IProps, any> {
	constructor(props) {
		super(props);

		this.goToCard = this.goToCard.bind(this);
		this.changeTab = this.changeTab.bind(this);
	}

	public componentDidMount() {
		if (this.props.location && this.props.location.query) {
			const categoryId = this.parseCategoryId();
			let order: number = null;
			const parsedOrderId = parseInt(this.props.location.query.o, 10);
			if (!isNaN(parsedOrderId)) {
				order = parsedOrderId;
			}
			let r1: number = null;
			const parsedr1 = parseInt(this.props.location.query.r1, 10);
			if (!isNaN(parsedr1)) {
				r1 = parsedr1;
			}
			let r2: number = null;
			const parsedr2 = parseInt(this.props.location.query.r2, 10);
			if (!isNaN(parsedr2)) {
				r2 = parsedr2;
			}
			let r3: boolean = null;
			if (this.props.location.query.r3) {
				r3 = this.props.location.query.r3 === 'true';
			}
			let r4: string = null;
			if (this.props.location.query.r4) {
				r4 = this.props.location.query.r4;
			}
			let r5: string = null;
			if (this.props.location.query.r5) {
				r5 = this.props.location.query.r5;
			}

			let keyword = this.props.params.keyword;
			if (keyword && keyword.length > 0) {
				keyword = decodeURIComponent(keyword);
			}
			this.props.changeTabAndGetRequiredData(
				c.SEARCHRESULTS_TAB_PRODUCT,
				categoryId,
				keyword,
				order,
				r1,
				r2,
				r3,
				r4,
				r5,
			);
		}
	}

	public componentDidUpdate(prevProps: IProps) {
		if (
			prevProps.location &&
			prevProps.location.query &&
			this.props.location &&
			this.props.location.query &&
			this.props.location.query !== prevProps.location.query
		) {
			const categoryId = this.parseCategoryId();
			let order: number = null;
			const parsedOrderId = parseInt(this.props.location.query.o, 10);
			if (!isNaN(parsedOrderId)) {
				order = parsedOrderId;
			}
			let r1: number = null;
			const parsedr1 = parseInt(this.props.location.query.r1, 10);
			if (!isNaN(parsedr1)) {
				r1 = parsedr1;
			}
			let r2: number = null;
			const parsedr2 = parseInt(this.props.location.query.r2, 10);
			if (!isNaN(parsedr2)) {
				r2 = parsedr2;
			}
			let r3: boolean = null;
			if (this.props.location.query.r3) {
				r3 = this.props.location.query.r3 === 'true';
			}
			let r4: string = null;
			if (this.props.location.query.r4) {
				r4 = this.props.location.query.r4;
			}
			let r5: string = null;
			if (this.props.location.query.r5) {
				r5 = this.props.location.query.r5;
			}

			let keyword = this.props.params.keyword;
			if (keyword && keyword.length > 0) {
				keyword = decodeURIComponent(keyword);
			}
			const { selectedTab } = this.props.search;
			this.props.changeTabAndGetRequiredData(
				selectedTab === c.SEARCHRESULTS_TAB_PRODUCT2 ? c.SEARCHRESULTS_TAB_PRODUCT2 : c.SEARCHRESULTS_TAB_PRODUCT,
				categoryId,
				keyword,
				order,
				r1,
				r2,
				r3,
				r4,
				r5,
			);
		}
	}

	public componentWillUnmount() {
		this.props.resetSearchData();
	}

	private parseCategoryId(): null | number {
		let categoryId: number = null;
		const parsedCategoryId = parseInt(this.props.location.query.cat, 10);
		if (!isNaN(parsedCategoryId)) {
			categoryId = parsedCategoryId;
		}
		if (!categoryId) {
			const { selectedTab } = this.props.search;
			if (selectedTab === c.SEARCHRESULTS_TAB_PRODUCT) {
				categoryId = RootCategory.Women;
			} else if (selectedTab === c.SEARCHRESULTS_TAB_PRODUCT2) {
				categoryId = RootCategory.Other;
			}
		}
		// TODO: check correct root category
		return categoryId;
	}

	private goToCard(id: string, type: string, target: string) {
		goToCard(this.props.dispatch, id, type, target);
	}

	private changeTab(
		selectedTab: string,
		categoryId: number,
		paramKeyword: string,
		order: number,
		r1: number,
		r2: number,
		r3: boolean,
		r4: string,
		r5: string,
	) {
		if (selectedTab === c.SEARCHRESULTS_TAB_PRODUCT) {
			categoryId = RootCategory.Women;
		} else if (selectedTab === c.SEARCHRESULTS_TAB_PRODUCT2) {
			categoryId = RootCategory.Other;
		}
		this.props.changeTabAndGetRequiredData(selectedTab, categoryId, paramKeyword, order, r1, r2, r3, r4, r5);
	}

	public render() {
		const { selectedTab } = this.props.search;
		const { t } = this.props;

		let categoryId: number = null;
		const parsedCategoryId = parseInt(this.props.location.query.cat, 10);
		if (!isNaN(parsedCategoryId)) {
			categoryId = parsedCategoryId;
		}
		let order: number = null;
		const parsedOrderId = parseInt(this.props.location.query.o, 10);
		if (!isNaN(parsedOrderId)) {
			order = parsedOrderId;
		}
		let r1: number = null;
		const parsedr1 = parseInt(this.props.location.query.r1, 10);
		if (!isNaN(parsedr1)) {
			r1 = parsedr1;
		}
		let r2: number = null;
		const parsedr2 = parseInt(this.props.location.query.r2, 10);
		if (!isNaN(parsedr2)) {
			r2 = parsedr2;
		}
		let r3: boolean = null;
		if (this.props.location.query.r3) {
			r3 = this.props.location.query.r3 === 'true';
		}
		let r4: string = null;
		if (this.props.location.query.r4) {
			r4 = this.props.location.query.r4;
		}
		let r5: string = null;
		if (this.props.location.query.r5) {
			r5 = this.props.location.query.r5;
		}

		let paramKeyword = this.props.params.keyword;
		if (paramKeyword && paramKeyword.length > 0) {
			paramKeyword = decodeURIComponent(paramKeyword);
		}

		return (
			<PortalOneColumnLayout>
				<div className="container-fluid searchResultsContainer">
					<div className="searchPageHolder">
						{paramKeyword && paramKeyword.length > 0 ? (
							<div className="container">
								<div className="message">
									<h2>
										{t('Search_SearchResults_SearchResultsFor')}{' '}
										<strong>
											“<span className="searchQuery">{paramKeyword}</span>”
										</strong>
									</h2>
								</div>
							</div>
						) : null}
						<Tabs
							renderActiveTabContentOnly={true}
							name="usercardtabs"
							tabComponent="div"
							disableInlineStyles={true}
							handleSelect={(selectedTab) => {
								this.changeTab(selectedTab, categoryId, paramKeyword, order, r1, r2, r3, r4, r5);
							}}
							/* selected tab name retrieved from external state */
							selectedTab={selectedTab}
						>
							<div className="resultsTab">
								<div className="tabLinksPositionMiddle">
									<TabLink key="productstablink" className="tabLink" to={c.SEARCHRESULTS_TAB_PRODUCT} default={true}>
										{this.props.t('Search_SearchResults_Clothes')}
									</TabLink>
									<TabLink key="products2tablink" className="tabLink" to={c.SEARCHRESULTS_TAB_PRODUCT2} default={true}>
										{this.props.t('Search_SearchResults_Cosmetics')}
									</TabLink>
									<TabLink key="shopstablink" className="tabLink" to={c.SEARCHRESULTS_TAB_SHOP}>
										{this.props.t('Search_SearchResults_Shops')}
									</TabLink>
									<TabLink key="articlestablink" className="tabLink" to={c.SEARCHRESULTS_TAB_ARTICLE}>
										{this.props.t('Search_SearchResults_Articles')}
									</TabLink>
									<TabLink key="usersstablink" className="tabLink" to={c.SEARCHRESULTS_TAB_USER}>
										{this.props.t('Search_SearchResults_Users')}
									</TabLink>
								</div>
							</div>
							<TabContent
								key="productstabcontent"
								className="searchResults"
								visibleClassName="contentVisible"
								for={c.SEARCHRESULTS_TAB_PRODUCT}
							>
								<ProductSearchResults
									key={1}
									goToCard={this.goToCard}
									location={this.props.location}
									usage={SearchUsage.ProductsSearch}
									categoriesSubset="primary"
								/>
							</TabContent>
							<TabContent
								key="products2tabcontent"
								className="searchResults"
								visibleClassName="contentVisible"
								for={c.SEARCHRESULTS_TAB_PRODUCT2}
							>
								<ProductSearchResults
									key={2}
									goToCard={this.goToCard}
									location={this.props.location}
									usage={SearchUsage.ProductsSearch}
									categoriesSubset="secondary"
								/>
							</TabContent>
							<TabContent
								key="shopstabcontent"
								className="searchResults"
								visibleClassName="contentVisible"
								for={c.SEARCHRESULTS_TAB_SHOP}
							>
								<ShopSearchResults />
							</TabContent>
							<TabContent
								key="articlestabcontent"
								className="searchResults"
								visibleClassName="contentVisible"
								for={c.SEARCHRESULTS_TAB_ARTICLE}
							>
								<ArticleSearchResults />
							</TabContent>
							<TabContent
								key="userstabcontent"
								className="searchResults"
								visibleClassName="contentVisible"
								for={c.SEARCHRESULTS_TAB_USER}
							>
								<UserSearchResults relativeUrl={this.props.location.pathname} />
							</TabContent>
						</Tabs>
					</div>
				</div>
				<Helmet meta={[{ name: 'robots', content: 'noindex, follow' }]} />
			</PortalOneColumnLayout>
		);
	}
}
export { SearchResults };
